export const ACTION = {
  DEDUCTIONLIST_REQUEST: "DEDUCTIONLIST_REQUEST",
  DEDUCTIONLIST_SUCCESS: "DEDUCTIONLIST_SUCCESS",
  DEDUCTIONLIST_ERROR: "DEDUCTIONLIST_ERROR",

  TRANSACTIONLIST_REQUEST: "TRANSACTIONLIST_REQUEST",
  TRANSACTIONLIST_SUCCESS: "TRANSACTIONLIST_SUCCESS",
  TRANSACTIONLIST_ERROR: "TRANSACTIONLIST_ERROR",
}
